// Useful Tools Hub Page
import React from 'react';
import { Link } from 'react-router-dom';
import '../../App.css';
import './Content.css';
import Footer from '../Footer';

export default function UsefulTools() {
  return (
    <>
      <div className="content-hub">
        <div className="content-hero">
          <h1>Useful Tools</h1>
          <p>Reference guides and utilities for IT professionals</p>
        </div>
        
        <div className="content-categories">
          <Link to="/tools/windows-eol" className="category-card category-tools">
            <div className="category-icon">
              <i className="fab fa-windows"></i>
            </div>
            <h2>Windows EOL</h2>
            <p>Windows End-of-Life dates and support information</p>
          </Link>

          <Link to="/tools/ms-security-cves" className="category-card category-tools">
            <div className="category-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h2>MS Security CVEs</h2>
            <p>Latest Microsoft security vulnerabilities and CVEs</p>
          </Link>

          <Link to="/tools/azure-eol" className="category-card category-tools">
            <div className="category-icon">
              <i className="fas fa-cloud"></i>
            </div>
            <h2>Azure Updates/EOL</h2>
            <p>Retirement dates and lifecycle information for Azure services and features</p>
          </Link>

          <Link to="/tools/azure-compute-optimiser" className="category-card category-tools">
            <div className="category-icon">
              <i className="fas fa-microchip"></i>
            </div>
            <h2>Azure Compute Optimiser</h2>
            <p>Upload a VM utilisation CSV to identify right-sizing opportunities and estimate savings</p>
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}
